export const PATH_POLICY = "/dieu-khoan-su-dung";

export const PATH_TERM_AND_CONDITION = "/chinh-sach-bao-mat";

export const ATADI_INFO = {
  logo: "https://statics.vntrip.vn/images/logo_atadi_vntrip.png",
  name: "CÔNG TY TNHH ATADI",
  nameEn: "VNTRIP TECHNOLOGY CO., LTD",
  address1: "Số 10/55 Thụy Khuê, Phường Thuỵ Khuê",
  address1En:
    "Office, 80-84 Thăng Long, Phường 4, Tân Bình, Hồ Chí Minh 700000",
  address2: "Quận Tây Hồ, Thành phố Hà Nội",
  address2En: "Tay Ho District, Hanoi City",
  bankName: "Vietcombank",
  bankNumber: "1023431230",
  bankBranch: "Thăng Long",
  businessRegistrationDate: "9/5/2016",
  email: "hotro@atadi.vn",
  hotline: "1900 636484",
  hotline_ve: "094 752 6688",
  zalo_link: "https://zalo.me/2387973882124211009",
  facebook_messenger_link: "https://m.me/731244416905124",
  facebook_link: "https://www.facebook.com/atadi.vn",
  appStore:
    "https://itunes.apple.com/us/app/vntrip-at-phong-khach-san/id1046183734?ls=1&mt=8",
  googlePlay: "https://play.google.com/store/apps/details?id=vn.vntrip.hotel",
};

export const LIST_LINK_FOOTER = [
  {
    link: `${process.env.REACT_APP_URL_ATADI}/ve-atadi`,
    value: `${process.env.REACT_APP_URL_ATADI}/ve-atadi`,
    label: "Về Atadi",
    isOpenNewTab: false,
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}/lien-he`,
    value: `${process.env.REACT_APP_URL_ATADI}/lien-he`,
    label: "Liên hệ",
    isOpenNewTab: false,
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}/dieu-khoan-su-dung`,
    value: `${process.env.REACT_APP_URL_ATADI}/dieu-khoan-su-dung`,
    label: "Điều khoản sử dụng",
    isOpenNewTab: false,
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}/quy-che-hoat-dong`,
    value: `${process.env.REACT_APP_URL_ATADI}/quy-che-hoat-dong`,
    label: "Quy chế hoạt động",
    isOpenNewTab: false,
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}/chinh-sach-bao-mat`,
    value: `${process.env.REACT_APP_URL_ATADI}/chinh-sach-bao-mat`,
    label: "Chính sách bảo mật",
    isOpenNewTab: false,
  },
  // {
  //     link: 'https://vntrip.com.vn/specialhotels/',
  //     label: 'Hợp tác khách sạn',
  //     isOpenNewTab: true,
  // },
  {
    link: "https://vntrip.vn/cam-nang",
    label: "Blog du lịch",
    isOpenNewTab: true,
  },
  // {
  //   link: "http://hr.vntrip.vn/",
  //   label: "Tuyển dụng",
  //   isOpenNewTab: true,
  // },
  // {
  //   link: "https://policy.vntrip.vn/loyalty-vntrip",
  //   label: "Hoàn tiền thành viên",
  //   isOpenNewTab: true,
  // },
  // {
  //   link: "https://partner.vntrip.vn/",
  //   label: "Hợp tác đại lý",
  //   isOpenNewTab: true,
  // },
];
